export default "__VITE_ASSET__DfKAteZn__"